let langTransition = {
    line1: {
        zh: '中国',
        en: 'U.S.A.'
    },
    line2: {
        zh: '北京',
        en: 'Las Vegas'
    },
    line3: {
        zh: '大董',
        en: 'The Buffet at Wynn'
    },
    title1: {
        zh: '大董',
        en: 'The Buffet at Wynn'
    },
    title2: {
        zh: '特色推荐',
        en: 'Recommendation'
    },
    title3: {
        zh: '情感评价',
        en: 'Sentiment Trend'
    },
    commentCount: {
        zh: '评价数量',
        en: 'Reviews',
    },
    commentCountNumber: {
        zh: '11622',
        en: '509',
    },
    starFull: {
        zh: 4,
        en: 4,
    },
    starHalf: {
        zh: 1,
        en: 0,
    },
    starEmpty: {
        zh: 0,
        en: 1,
    },
    poiType: {
        zh: '北京菜/东城区',
        en: 'Buffet',
    },
    priceNumber: {
        zh: 306,
        en: 287
    },
    addrKey: {
        zh: '地址',
        en: 'Address',
    },
    addrValue: {
        zh: '东四十条甲22号南新仓商务大厦1-2楼',
        en: '3131 South Las Vegas Boulverd, Wynn, Las Vegas, NV',
    },
    tasteKey: {
        zh: '口味',
        en: 'Taste',
    },
    environmentKey: {
        zh: '环境',
        en: 'Environment'
    },
    serviceKey: {
        zh: '服务',
        en: 'Service'
    },
    specialDishKey: {
        zh: '推荐菜',
        en: 'Special'
    },
    specialDishValue: {
        zh: '烤鸭',
        en: 'Lobster Soup'
    },
    recommendedReasonKey: {
        zh: '推荐理由',
        en: 'What\'s cool'
    },
    recommendedReasonValue: {
        zh: '松鼠桂鱼最好吃的松鼠鳜鱼',
        en: 'Buffet at the famous Wynn Hotel'
    },
    likeKey: {
        zh: '喜欢',
        en: 'Like'
    },
    neutralKey: {
        zh: '中性',
        en: 'Neutral'
    },
    dislikeKey: {
        zh: '讨厌',
        en: 'Dislike'
    },
};

let getLangTransition = (lang = window.$lang) => {
    let obj = {};
    for (let key in langTransition) {
        obj[key] = langTransition[key][lang];
    }
    return obj;
};

let langTransitionObj = getLangTransition($qsObj.lang || window.$lang);

export default langTransitionObj;
